import * as Yup from 'yup'

export const contractTermSchema = Yup.object().shape({
  name: Yup.string()
    .max(64, 'Máximo 64 caracteres')
    .required('Insira o nome'),
  description: Yup.string()
    .max(255, 'Máximo 255 caracteres')
    .required('Insira a descrição'),
  content: Yup.string().required('Insira o conteúdo do termo'),
});
